import classNames from 'classnames/bind';
import React from 'react';

import { Tooltip } from '../Tooltip/Tooltip';
import type { IInput } from './Input';

import styles from './Input.module.scss';
import CheckIcon from '@icons/check.svg';
import CrossIcon from '@icons/crossThin.svg';

export interface IProps extends IInput {
  touched: boolean;
  value: string;
  error: string | undefined;
  tooltipText?: string;
  showError?: boolean;
  isInput?: boolean;
  showValidationIcon?: boolean;
  children: React.ReactNode;
}

const cx = classNames.bind(styles);

export const InputGroup: React.FC<IProps> = ({
  id,
  label,
  required,
  optional = false,
  children,
  error,
  touched,
  value,
  tooltipText,
  showError = true,
  showValidationIcon = true,
  isInput,
  testId,
  className,
}) => (
  <div className={cx('container', className, { isInput })}>
    {label && (
      <label className={styles.label} htmlFor={id}>
        {label}
        {required && <span className={styles.labelRequired}>*</span>}
        {optional && <span className={styles.labelOptional}> (optional)</span>}
        {tooltipText && <Tooltip className={styles.tooltip} text={tooltipText} />}
      </label>
    )}
    <span className={styles.inputWrapper}>
      {children}
      {showValidationIcon &&
        touched &&
        ((value !== '' && optional) ||
          (!optional && error !== undefined) ||
          (!optional && error === undefined && value !== '')) && (
          <span
            className={cx('stateIconWrapper', { isError: error })}
            data-testid={`${testId}-icon`}
          >
            {error ? (
              <CrossIcon className={styles.icon} data-testid={`${testId}-icon`} />
            ) : (
              <CheckIcon className={styles.icon} data-testid={`${testId}-icon`} />
            )}
          </span>
        )}
    </span>
    {touched && error && showError && <span className={styles.error}>{error}</span>}
  </div>
);
